<template>
  <div v-if="ready" :class="['app', deviceClass]">
    <Header :minimal="$route.name === 'home'" :transparent="$route.name === 'home'" />
    <div class="section" v-if="!isInstallationFetching && installation">
      <div class="t-wrapper" >
        <ExploreByFamilies :style="{visibility: $route.name==='ExploreByFamilies'?'visible':'hidden'}" :active="$route.name==='ExploreByFamilies'"></ExploreByFamilies>
        <ExploreByConcepts :style="{visibility: $route.name==='ExploreByConcepts'?'visible':'hidden'}" :active="$route.name==='ExploreByConcepts'"></ExploreByConcepts>
      </div>
      <transition-group name="fade" tag="div" class="t-wrapper" v-if="$route.name!=='ExploreByFamilies' && $route.name!=='ExploreByConcepts'"> 
        <router-view :key="$route.name" />
      </transition-group>
    </div>

    <restart-view v-model="innactive" />
  </div>
</template>

<script>
// import {getProfile} from '@/services/Api'
import Header from "@/components/Header.vue";
import RestartView from "@/components/RestartView";
import device from "@/utils/device";
import { mapActions, mapGetters } from "vuex";
import Languages from "./vue-plugins/Languages";
import ExploreByConcepts from "./views/ExploreByConcepts.vue";
import ExploreByFamilies from "./views/ExploreByFamilies.vue";

const RESET_INTERVAL = 1 * 60 * 1000;
export default {
  name: "app",
  metaInfo: {
    titleTemplate: "Duty Free - %s",
    meta: [
      {
        vmid: "og:type",
        name: "og:type",
        content: "website",
      },
    ],
  },
  components: {
    Header,
    RestartView,
    ExploreByConcepts,
    ExploreByFamilies
  },
  mixins: [Languages],
  mounted() {
    this.fetchInstallation(this.$route.params.installation)

    document.documentElement.setAttribute("lang", this.$store.state.i18n.lang);
    let onInteract = () => {
      clearTimeout(this.resetTimer);
      this.resetLoop();
    };
    this.resetLoop()
    window.addEventListener("click", onInteract);
    window.addEventListener("mouseup", onInteract);
    if (this.installation) this.fetchEvent()
    // this.killLoop()
  },
  watch: {
    installation() {
      if (this.installation) this.fetchEvent()
    }
  },
  data() {
    return {
      showFooter: !localStorage.getItem("accepted_cookies"),
      ready: false,
      innactive: false
    };
  },
  computed: {
    ...mapGetters(['isInstallationFetching', 'installation']),
    deviceClass() {
      return device;
    },
  },
  methods: {
    ...mapActions(['fetchInstallation']),
    fetchEvent() {
      this.eventTracker.emitEvent("NEW_SESSION");
      this.ready = true;
      // this.$store.dispatch('initSession', this.eventTracker).then(()=> {
      //   this.ready=true
      // })
      this.eventTracker.emitEvent("REFFERRER", {
        url: document.referrer,
        target: window.location.href,
      });
    },
    checkLandscape(angle) {
      const bool = this.isMobile && Math.abs(angle % 180) === 90;
      this.landscape = bool;
      return bool;
    },
    acceptCookies() {
      localStorage.setItem("accepted_cookies", true);
      this.showFooter = !localStorage.getItem("accepted_cookies");
    },
    resetLoop() {
      this.resetTimer = setTimeout(() => {
        console.log('reste loop')
        if (this.$route.name === "home") return;
        if (!this.innactive) {
          this.innactive = true;
          this.resetLoop();
        } else {
          console.log('reset loop to welcome')
          this.$router.push({ name: "home", params: { lang: this.$route.params.defaultLang } });
          this.innactive = false
        }
      }, RESET_INTERVAL);
    },
    // killLoop(){
    //   if(this.$route.name==='ExploreByFamilies') this.$router.push({name:'ExploreByConcepts'})
    //   else  this.$router.push({name:'ExploreByFamilies'})
    //   setTimeout(this.killLoop,100)
    // }
  },
};
</script>
<style lang="stylus">
body
  margin: 0

a
  color: inherit
  text-decoration: none

a:hover
  color: inherit
  cursor: pointer
  text-decoration: none
</style>
<style scoped lang="stylus">
.landscape-wrapper
  height: 100%

  .landscape
    align-items: center
    display: flex
    flex-direction: column
    height: 100%
    justify-content: center

    .icon
      m-icon("turn-your-device", 50)

    .message
      m-font("WaverlyCF", "medium")

.app
  background-image: url("~@/assets/images/V4_desktop.jpg")
  background-position: center center
  background-repeat: no-repeat
  background-size: cover
  display: flex
  flex-direction: column
  height: 100%
  overflow: hidden
  width: 100%

  .section
    flex: 1 1 0%
    height: 100%
    left: 0
    overflow: hidden
    position: relative
    top: 0
    width: 100%
    z-index: 0

    .t-wrapper
      display: flex
      flex: 1 1 0%
      height: 100%
      overflow: hidden
      position: relative
      position: absolute
      width: 100%
      z-index: 0

      > div
        flex: 1 1 0%
        height: 100%
        overflow: hidden
        position: absolute
        width: 100%

        &.fade-enter-active,
        &.fade-leave-active
          transition: opacity 0.4s

        &.fade-enter,
        &.fade-leave-to
          opacity: 0

    .section-overlay
      // background-color: #000
      height: 100%
      position: absolute
      width: 100%
      z-index: 1

      &.fade-enter-active,
      &.fade-leave-active
        transition: opacity 0.4s

      &.fade-enter,
      &.fade-leave-to
        opacity: 0

  .legal-overlay
    display: none
    height: 100%
    position: absolute
    width: 100%
    z-index: 2

    &.showLegal
      display: inline

    &.fade-enter-active,
    &.fade-leave-active
      transition: opacity 0.4s

    &.fade-enter,
    &.fade-leave-to
      opacity: 0
</style>
